module.exports = __webpack_public_path__ + "static/media/eap4.bc29de09.md";